import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';
import { WinePackageWidgetModel } from 'shared-widget-components/src/services/FeaturedPackagesService';
import useWinePackageUrl from '../hooks/useWinePackageUrl';

/**
 * The WinePackageImage component renders the image of a wine package.
 * @param winePackage - The wine package to render.
 * @returns The WinePackageImage component is returning JSX elements.
 */

export const WinePackageImage = ({ winePackage }: { winePackage: WinePackageWidgetModel }) => {
  const { onPackageClick } = useWinePackageUrl({ winePackage });

  if (!winePackage.showWineBottlesInFront) {
    return <CDNImage imageHeight={277} imageWidth={370} fit='crop' className='rounded-md cursor-pointer' alt={winePackage.backgroundImage} src={winePackage.backgroundImage} onClick={onPackageClick} />;
  }

  return (
    <div className='relative rounded-md'>
      <CDNImage imageHeight={277} imageWidth={370} fit='crop' src={winePackage.backgroundImage} alt={winePackage.backgroundImage} className='rounded-md cursor-pointer' onClick={onPackageClick} />
      <div className='absolute w-3/4 h-full mx-auto inset-0 flex justify-center items-center'>
        <CDNImage imageHeight={220} imageWidth={280} fit='crop' src={winePackage.foregroundImage} alt={winePackage.foregroundImage} className='rounded-md cursor-pointer' onClick={onPackageClick} />
      </div>
    </div>
  );
};
